import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Tag } from "./ui";

const firstImage = (project) => {
  if (project.image) return project.image;
  if (project.images) return Object.values(project.images)[0];
  return null;
};

const ProjectCard = ({ project, id }) => {
  const img = firstImage(project);

  return (
    <article
      id={id}
      className="scroll-mt-24 border-b border-line py-12 first:pt-0 last:border-0 sm:py-16"
    >
      <div className="grid gap-8 lg:grid-cols-5 lg:gap-12">
        {img && (
          <div className="lg:col-span-2">
            <img
              src={img}
              alt={`${project.title} screenshot`}
              loading="lazy"
              className="w-full rounded-lg border border-line object-cover"
            />
          </div>
        )}

        <div className={img ? "lg:col-span-3" : "lg:col-span-5"}>
          <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
            <h3 className="text-2xl font-bold text-ink">{project.title}</h3>
            {project.period && (
              <span className="font-mono text-sm font-medium text-ink-faint">{project.period}</span>
            )}
          </div>
          <p className="mt-1 text-ink-soft">{project.role}</p>

          <p className="mt-4 text-ink-soft">{project.description}</p>

          {project.achievements && (
            <ul className="mt-5 space-y-2">
              {project.achievements.map((a, i) => (
                <li key={i} className="flex gap-3 text-sm text-ink-soft">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          )}

          <div className="mt-6 flex flex-wrap gap-2">
            {project.tech?.map((t) => (
              <Tag key={t}>{t}</Tag>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap gap-5">
            {project.live && (
              <a
                href={project.live}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm font-medium text-accent hover:text-accent-dark"
              >
                Visit site <ArrowUpRight className="h-4 w-4" />
              </a>
            )}
            {project.links &&
              Object.entries(project.links).map(([key, href]) => (
                <a
                  key={key}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-sm font-medium text-accent hover:text-accent-dark"
                >
                  {key.charAt(0).toUpperCase() + key.slice(1)} <ArrowUpRight className="h-4 w-4" />
                </a>
              ))}
          </div>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
